module.exports = __webpack_public_path__ + "static/media/TSAWeb3MusicBox.33f47bce.png";